exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".lnk-btn-minus {\n  color: #c13939;\n  cursor: pointer;\n  margin-right: 20px; }\n", "", {"version":3,"sources":["/Users/jean-philippe/_work/rs-webapp/rs-lightbox-old/client/app/pages/asset/linked-assets/linked-assets.scss"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB,EAAE","file":"linked-assets.scss","sourcesContent":[".lnk-btn-minus {\n  color: #c13939;\n  cursor: pointer;\n  margin-right: 20px; }\n"],"sourceRoot":""}]);

// exports
